












































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ICurrency } from "@/models/constants";
import { ValidationObserver } from "vee-validate";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import HasValidation from "@/mixins/HasValidation";

@Component
export default class ChangeAmountModal extends Mixins(
  CurrenciesStore,
  HasValidation
) {
  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ default: 0 })
  public amount!: number;

  @Prop({ default: null })
  public maxAmount!: number | null;

  @Prop({ default: "" })
  public currencyCode!: ICurrency["code"];

  // Data

  public newAmount = 0;

  // Life-cycle Methods

  public async created() {
    this.newAmount = this.amount;
  }

  // Computed

  public get currency(): ICurrency {
    return this.$_.find(this.currencies, [
      "code",
      this.currencyCode
    ]) as ICurrency;
  }

  public get formIsInvalid() {
    return !this.newAmount || this.hasErrors;
  }

  // Methods

  public async validateBeforeSubmit() {
    if (this.formIsInvalid) return;
    this.$emit("success", this.newAmount);
    this.$emit("close");
  }
}
